/**
 * Enum representing the platform the app is running on
 */
export enum Platform {
    IOS = 'ios',
    ANDROID = 'android'
}
